import styled from 'styled-components';
import { loaderAnimationStyles } from '@dealstack/frontend/shared/components/loaders/shared/loaderAnimation.styles';

export const BigLoaderAnimationStyles = styled.div`
	z-index: 999999;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;

	svg {
		width: clamp(10rem, 15vw, 30rem) !important;
		height: auto;
	}

	${loaderAnimationStyles}
`;
